<template>
  <div>
    <div class="ERR404">
      <router-link to="/">
        <img src="../../assets/images/ERR404.gif" alt />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "enterprise",
  mounted() {
    setTimeout(() => {
      this.$router.push("/");
    }, 5000);
  },
};
</script>

<style lang="stylus" scoped>
.ERR404 {
  text-align: center;
}
</style>
